export default __webpack_public_path__ + "static/media/IMG_2717.377545f2.jpg";